import { BeneficiaryFilterItem } from '@repo/shared/dtos/beneficiary'
import {
  BooleanSchemaItem,
  DateSchemaItem,
  EnumSchemaItem,
  MultiselectSchemaItem,
  NumberSchemaItem,
  StringSchemaItem,
  StructuredDataSchemaItem,
} from '@repo/shared/dtos/structured-data'

import MultiselectFilter from '@/components/beneficiary/list/filters/MultiselectFilter'

import BooleanFilter from './BooleanFilter'
import DateFilter from './DateFilter'
import EnumFilter from './EnumFilter'
import NumberFilter from './NumberFilter'
import StringFilter from './StringFilter'

type FilterItemProps =
  | {
      filter: BeneficiaryFilterItem
      schemaItem: StructuredDataSchemaItem
      onChange: (filter: BeneficiaryFilterItem) => void
      onRemove: (filter: BeneficiaryFilterItem) => void
      readonly?: false
    }
  | {
      filter: BeneficiaryFilterItem
      schemaItem: StructuredDataSchemaItem
      readonly: true
    }

export default function FilterItem({ filter, schemaItem, ...rest }: FilterItemProps) {
  switch (filter.type) {
    case 'string':
      return StringFilter({ schemaItem: schemaItem as StringSchemaItem, filter, ...rest })
    case 'number':
      return NumberFilter({ schemaItem: schemaItem as NumberSchemaItem, filter, ...rest })
    case 'boolean':
      return BooleanFilter({ schemaItem: schemaItem as BooleanSchemaItem, filter, ...rest })
    case 'enum':
      return EnumFilter({ schemaItem: schemaItem as EnumSchemaItem, filter, ...rest })
    case 'multiselect':
      return MultiselectFilter({ schemaItem: schemaItem as MultiselectSchemaItem, filter, ...rest })
    case 'date':
      return DateFilter({ schemaItem: schemaItem as DateSchemaItem, filter, ...rest })
  }
}
